class CartDrawer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.initOverlay();
    this.setHeaderCartIconAccessibility();
  }

  initOverlay() {
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);

    }, { once: true });

    let header = document.querySelector("#shopify-section-header");
    header.classList.remove("shopify-section-header-hidden" );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);


      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }



  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {

    const cartid = 'CartDrawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.querySelector('.cart-drawer');
    const source = html.getElementById(cartid);
    //console.log("cartid" , cartid , destination , source)
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelector('cart-drawer').initOverlay();

    const drawerInner = document.querySelector('.drawer__inner');
    if(drawerInner.classList.contains('is_min_qty_livia')){
      //console.log('Drawer If called');

      const choiceRadio = document.querySelector(".choice_row.active input");
      if(choiceRadio) {

        if (choiceRadio.dataset.sub == "one-time") {
          if(document.querySelector(".trigger_btn")) {
            document.querySelector(".trigger_btn").style.display = "block";
            console.log('one-time trigger_btn called');
          }
          if(document.querySelector(".custom_trigger_btn")) {
            document.querySelector(".custom_trigger_btn").style.display = "none";
            console.log('one-time custom_trigger_btn called');
          }
          console.log('one-time If called');
        }else{
          if(document.querySelector(".custom_trigger_btn")) {
            document.querySelector(".custom_trigger_btn").style.display = "block";
          }
          if(document.querySelector(".trigger_btn")) {
            document.querySelector(".trigger_btn").style.display = "none";
          }
          console.log('one-time Else called');
        }

        if (choiceRadio.dataset.sub == "subscription") {
          if(document.querySelector(".custom_trigger_btn")) {
            document.querySelector(".custom_trigger_btn").style.display = "block";
          }
          if(document.querySelector(".trigger_btn")) {
            document.querySelector(".trigger_btn").style.display = "none";
          }
          console.log('subscription If called');
        }else{
          if(document.querySelector(".trigger_btn")) {
            document.querySelector(".trigger_btn").style.display = "block";
            console.log('subscription trigger_btn called');
          }
          if(document.querySelector(".custom_trigger_btn")) {
            document.querySelector(".custom_trigger_btn").style.display = "none";
            console.log('subscription custom_trigger_btn called');
          }
          console.log('subscription Else called');
        }

      }




    }else{
      //console.log('Drawer Else called');
      if(document.querySelector(".custom_trigger_btn")) {
        document.querySelector(".custom_trigger_btn").style.display = "none";
      }
      if(document.querySelector(".trigger_btn")) {
        document.querySelector(".trigger_btn").style.display = "block";
      }
      if(document.querySelector(".min_qty_err")) {
        document.querySelector(".min_qty_err").style.display = "none";
      }
    }

  });

  fetch(window.Shopify.routes.root +'?section_id=cart-icon-bubble')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid_2 = 'cart-icon-bubble';
    const html_2 = new DOMParser().parseFromString(responseText, 'text/html')
    const destination_2 = document.querySelector('.cart-icon-bubble');
    const source_2 = html_2.getElementById(cartid_2);

    if (source_2 && destination_2) destination_2.innerHTML = source_2.innerHTML;
    document.querySelector('cart-drawer').initOverlay();
  });

}

setTimeout(function() { load_cart() }, 1000);

// function removeItem(data_line){
//   const data = {'line': data_line ,'quantity': 0 };
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   })
//   .then((response) => response.json())
//   .then((data) => {
//     load_cart();
//     console.log('eeee');
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
// }



// const url = '/cart.js';

// fetch(url)
// .then((resp) => resp.json())
// .then(function(data) {
//     console.log('data--',data);
// })
// .catch(function(error) {
//   console.log(error);
// })
